<!-- page title -->
<div class="page-title" *ngIf="false">
    <h2> IN APP BANNER </h2>
</div>





<!-- grid -->
<div class="border-box-shadow no-padding">

    <mat-tab-group mat-align-tabs="center">

        <mat-tab label="General Contractor">
            <br />
            <table mat-table [dataSource]="dataSource">
                <!-- Activity Column -->
                <ng-container matColumnDef="Perticular">
                    <th mat-header-cell *matHeaderCellDef> Questions </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- Project Type Column -->
                <ng-container matColumnDef="Score">
                    <th mat-header-cell *matHeaderCellDef> Thank You Message </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Thank You for your intrest </p>
                    </td>
                </ng-container>

                <!-- Not intrested msg  -->
                <ng-container matColumnDef="no">
                    <th mat-header-cell *matHeaderCellDef> Not intrested Reply </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Thank you for not intrest </p>
                    </td>
                </ng-container>
                <!-- Not intrested msg  -->
                <ng-container matColumnDef="yes_img">
                    <th mat-header-cell *matHeaderCellDef> Intrested Image </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <img src="../../../../../assets/pdf.png" width="50%" alt="error" />
                    </td>
                </ng-container>
                <!-- Not intrested msg  -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef> Title </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Multi GST ? </p>
                    </td>
                </ng-container>




                <!-- action button -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <button class="btn btn-info" (click)="UpdateKycScore()">Update</button> -->

                        <!-- *ngIf="element.is_active" -->
                        <div class="table-action-button" fxLayout="row" fxLayoutAlign="center center"
                            fxLayoutGap="20px">
                            <!-- *ngIf="checkPermission('edit_masters')" -->
                            <a href="javascript:;" class="edit-icon table-icon" matTooltip="Edit">
                                <mat-icon>create</mat-icon>
                            </a>
                            <!-- *ngIf="checkPermission('delete_masters')"  -->
                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="Delete"
                                (click)="InAppAdd(element.id)">
                                <mat-icon>delete</mat-icon>
                            </a>
                            <!-- *ngIf="!checkPermission('edit_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">create</mat-icon> -->

                            <!-- *ngIf="!checkPermission('delete_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">delete</mat-icon> -->
                        </div>

                        <!-- *ngIf="!element.is_active" -->
                        <div class="table-action-button" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                            *ngIf="element.is_active">

                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="view"
                                style="color: #0052cc;" [queryParams]="{view: 'true'}">
                                <mat-icon>remove_red_eye</mat-icon>
                            </a>

                            <!-- *ngIf="checkPermission('reactivate_masters')"  -->
                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="Reactivate"
                                style="color: #0052cc;" (click)="reActivate(element.id)">
                                <mat-icon>settings_backup_restore</mat-icon>
                            </a>
                            <!-- *ngIf="!checkPermission('reactivate_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">settings_backup_restore</mat-icon> -->
                        </div>


                    </td>

                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


        </mat-tab>
        <mat-tab label="Labor Contractor">
            <table mat-table [dataSource]="dataSource">
                <!-- Activity Column -->
                <ng-container matColumnDef="Perticular">
                    <th mat-header-cell *matHeaderCellDef> Questions </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- Project Type Column -->
                <ng-container matColumnDef="Score">
                    <th mat-header-cell *matHeaderCellDef> Thank You Message </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Thank You for your intrest </p>
                    </td>
                </ng-container>

                <!-- Not intrested msg  -->
                <ng-container matColumnDef="no">
                    <th mat-header-cell *matHeaderCellDef> Not intrested Reply </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Thank you for not intrest </p>
                    </td>
                </ng-container>
                <!-- Not intrested msg  -->
                <ng-container matColumnDef="yes_img">
                    <th mat-header-cell *matHeaderCellDef> Intrested Image </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <img src="../../../../../assets/pdf.png" width="50%" alt="error" />
                    </td>
                </ng-container>
                <!-- Not intrested msg  -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef> Title </th>
                    <td mat-cell *matCellDef="let element" style=" width: 18%;">
                        <p>Multi GST ? </p>
                    </td>
                </ng-container>




                <!-- action button -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <button class="btn btn-info" (click)="UpdateKycScore()">Update</button> -->

                        <!-- *ngIf="element.is_active" -->
                        <div class="table-action-button" fxLayout="row" fxLayoutAlign="center center"
                            fxLayoutGap="20px">
                            <!-- *ngIf="checkPermission('edit_masters')" -->
                            <a href="javascript:;" class="edit-icon table-icon" matTooltip="Edit">
                                <mat-icon>create</mat-icon>
                            </a>
                            <!-- *ngIf="checkPermission('delete_masters')"  -->
                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="Delete"
                                (click)="InAppAdd(element.id)">
                                <mat-icon>delete</mat-icon>
                            </a>
                            <!-- *ngIf="!checkPermission('edit_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">create</mat-icon> -->

                            <!-- *ngIf="!checkPermission('delete_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">delete</mat-icon> -->
                        </div>

                        <!-- *ngIf="!element.is_active" -->
                        <div class="table-action-button" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                            *ngIf="element.is_active">

                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="view"
                                style="color: #0052cc;" [queryParams]="{view: 'true'}">
                                <mat-icon>remove_red_eye</mat-icon>
                            </a>

                            <!-- *ngIf="checkPermission('reactivate_masters')"  -->
                            <a href="javascript:;" class="delete-icon table-icon" matTooltip="Reactivate"
                                style="color: #0052cc;" (click)="reActivate(element.id)">
                                <mat-icon>settings_backup_restore</mat-icon>
                            </a>
                            <!-- *ngIf="!checkPermission('reactivate_masters')" -->
                            <!-- <mat-icon style="color: darkgrey;" matTooltip="Permission not granted">settings_backup_restore</mat-icon> -->
                        </div>


                    </td>

                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-tab>



    </mat-tab-group>

</div>